import type { Immutable } from "immer";
import React from "react";

import { Context, templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { ReviewsViewerSSR } from "../../apps/reviews/ReviewsViewerSSR";
import { reviewsRightBarComponentsMap } from "../../blocks/componentMaps";

import styles from "./index.module.scss";

const ReviewsPageRightBar = (
    props: Immutable<{ page: templates.ReviewsPageDocumentTemplate["page"] }>,
): React.JSX.Element => (
    <>
        {props.page.right_bar.value.map((block) => (
            <StreamField
                key={block.id}
                tagName="div"
                attrs={{
                    className: `w-block-${block.type} block-${block.type}`,
                }}
                value={[block]}
                components={reviewsRightBarComponentsMap}
            />
        ))}
    </>
);

// review-sidebar and sidebar-section--shop-now stay global: the right-bar
// blocks rendered into them (ReviewsRightBarSection) select on them.
export const ReviewsPageBody = (
    props: Immutable<
        Omit<templates.ReviewsPageDocumentTemplate, "page_chrome">
    >,
): React.JSX.Element => {
    const staticBase = React.useContext(Context).chrome.static_base;
    return (
        <>
            <section
                className={concatClassNames([styles.hero, "reviews", "hero"])}
            >
                <div className="main-container">
                    <div className={styles.reviewsHeroInfo}>
                        <h2>Customer Reviews</h2>
                        <h5>(You&rsquo;re Making Us Blush)</h5>
                    </div>
                </div>
            </section>
            <section className={styles.reviewSection}>
                <div className="main-container">
                    <div className={styles.reviewContent}>
                        <div className="reviews-app">
                            <ReviewsViewerSSR
                                brand_id={props.brand_id}
                                product_type_whitelist_ids={
                                    props.product_type_whitelist_ids
                                }
                                default_sort={props.default_sort}
                                show_sources={props.show_sources}
                                write_review_url={props.write_review_url}
                                show_applied_filters={
                                    props.show_applied_filters
                                }
                                products_data={props.products_data}
                                reviews_data={props.reviews_data}
                                facets_data={props.facets_data}
                            />
                        </div>
                    </div>
                    <div
                        className={concatClassNames([
                            styles.reviewSidebar,
                            "review-sidebar",
                        ])}
                    >
                        <div
                            className={concatClassNames([
                                styles.sidebarSection,
                                "sidebar-section--shop-now",
                            ])}
                        >
                            <ReviewsPageRightBar page={props.page} />
                        </div>
                        <div className={styles.sidebarSection}>
                            <img
                                className={styles.sidebarSectionIcon}
                                src={`${staticBase}img/global/moon-stars.svg`}
                                alt="Moon With Stars Icon"
                                loading="lazy"
                                decoding="async"
                            />
                            <h4 className={styles.sidebarSectionTitle}>
                                100 Night Trial
                            </h4>
                            <p
                                className={concatClassNames([
                                    styles.sidebarSectionCopy,
                                    "caption-light",
                                ])}
                            >
                                We want you to get the best sleep of your life.
                                That&rsquo;s why we give you 100 nights to try
                                our products. If you don&rsquo;t love it,
                                we&rsquo;ll refund you&mdash;no questions asked.
                            </p>
                            <a
                                className={styles.sidebarSectionLink}
                                href={props.support_url}
                            >
                                learn more
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
